import { DeleteExpensePage } from "@/app/pages/DeleteExpensePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_recent/hapus")({
  component: DeleteExpensePage,
  validateSearch: (search: Record<string, unknown>) => {
    if (typeof window === "undefined") return { id: null };

    const expenses = JSON.parse(localStorage.getItem("expenses") || "[]");
    const expense = expenses.find((expense: any) => expense.id === search.id);

    return {
      id: expense ? expense.id : null,
    };
  },
});
